// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2ggjy","title":"FrontImage_title__30DtE"};